export default __webpack_public_path__ + "static/media/star-glyph-16-px-yellow.11845a51.svg";